import { Link } from "react-router-dom";
import { useEffect } from "react";

export default function NotFound() {
    useEffect(() => {
        document.title = "Surveys2CAD | Page not found";
    }, []);
    return (
        <div className="max-w-3xl mx-auto px-5 py-32 text-center" data-testid="not-found">
            <div className="overline mb-3">404</div>
            <h1 className="font-heading text-6xl font-bold text-slate-50 tracking-tighter">
                Off the <span className="text-cyan-400">grid.</span>
            </h1>
            <p className="text-slate-400 mt-4">
                This page isn't in our coordinate system. Let's get you back on point.
            </p>
            <Link to="/" className="btn-primary mt-8 inline-flex" data-testid="back-home-btn">
                Back to home
            </Link>
        </div>
    );
}
